module.exports = __webpack_public_path__ + "img/monitor.4f7d0997.svg";